// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SpeciesFieldsFragment = { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean };

export type CreateSpeciesMutationVariables = Types.Exact<{
  data: Types.CreateSpeciesInput;
}>;


export type CreateSpeciesMutation = { __typename?: 'Mutation', createSpecies: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } };

export type UpdateSpeciesMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  data: Types.UpdateSpeciesInput;
}>;


export type UpdateSpeciesMutation = { __typename?: 'Mutation', updateSpecies: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } };

export type DeleteSpeciesMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteSpeciesMutation = { __typename?: 'Mutation', deleteSpecies: { __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean } };

export type AllSpeciesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllSpeciesQuery = { __typename?: 'Query', allSpecies: Array<{ __typename?: 'Species', id: string, type: Types.SpeciesType, name: string, keywords?: Array<string> | null, is_archived: boolean }> };

export const SpeciesFieldsFragmentDoc = gql`
    fragment SpeciesFields on Species {
  id
  type
  name
  keywords
  is_archived
}
    `;
export const CreateSpeciesDocument = gql`
    mutation createSpecies($data: CreateSpeciesInput!) {
  createSpecies(data: $data) {
    ...SpeciesFields
  }
}
    ${SpeciesFieldsFragmentDoc}`;
export type CreateSpeciesMutationFn = Apollo.MutationFunction<CreateSpeciesMutation, CreateSpeciesMutationVariables>;

/**
 * __useCreateSpeciesMutation__
 *
 * To run a mutation, you first call `useCreateSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpeciesMutation, { data, loading, error }] = useCreateSpeciesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpeciesMutation, CreateSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSpeciesMutation, CreateSpeciesMutationVariables>(CreateSpeciesDocument, options);
      }
export type CreateSpeciesMutationHookResult = ReturnType<typeof useCreateSpeciesMutation>;
export type CreateSpeciesMutationResult = Apollo.MutationResult<CreateSpeciesMutation>;
export type CreateSpeciesMutationOptions = Apollo.BaseMutationOptions<CreateSpeciesMutation, CreateSpeciesMutationVariables>;
export const UpdateSpeciesDocument = gql`
    mutation updateSpecies($id: ID!, $data: UpdateSpeciesInput!) {
  updateSpecies(id: $id, data: $data) {
    ...SpeciesFields
  }
}
    ${SpeciesFieldsFragmentDoc}`;
export type UpdateSpeciesMutationFn = Apollo.MutationFunction<UpdateSpeciesMutation, UpdateSpeciesMutationVariables>;

/**
 * __useUpdateSpeciesMutation__
 *
 * To run a mutation, you first call `useUpdateSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpeciesMutation, { data, loading, error }] = useUpdateSpeciesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpeciesMutation, UpdateSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpeciesMutation, UpdateSpeciesMutationVariables>(UpdateSpeciesDocument, options);
      }
export type UpdateSpeciesMutationHookResult = ReturnType<typeof useUpdateSpeciesMutation>;
export type UpdateSpeciesMutationResult = Apollo.MutationResult<UpdateSpeciesMutation>;
export type UpdateSpeciesMutationOptions = Apollo.BaseMutationOptions<UpdateSpeciesMutation, UpdateSpeciesMutationVariables>;
export const DeleteSpeciesDocument = gql`
    mutation deleteSpecies($id: ID!) {
  deleteSpecies(id: $id) {
    ...SpeciesFields
  }
}
    ${SpeciesFieldsFragmentDoc}`;
export type DeleteSpeciesMutationFn = Apollo.MutationFunction<DeleteSpeciesMutation, DeleteSpeciesMutationVariables>;

/**
 * __useDeleteSpeciesMutation__
 *
 * To run a mutation, you first call `useDeleteSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpeciesMutation, { data, loading, error }] = useDeleteSpeciesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpeciesMutation, DeleteSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpeciesMutation, DeleteSpeciesMutationVariables>(DeleteSpeciesDocument, options);
      }
export type DeleteSpeciesMutationHookResult = ReturnType<typeof useDeleteSpeciesMutation>;
export type DeleteSpeciesMutationResult = Apollo.MutationResult<DeleteSpeciesMutation>;
export type DeleteSpeciesMutationOptions = Apollo.BaseMutationOptions<DeleteSpeciesMutation, DeleteSpeciesMutationVariables>;
export const AllSpeciesDocument = gql`
    query allSpecies {
  allSpecies {
    ...SpeciesFields
  }
}
    ${SpeciesFieldsFragmentDoc}`;

/**
 * __useAllSpeciesQuery__
 *
 * To run a query within a React component, call `useAllSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSpeciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSpeciesQuery(baseOptions?: Apollo.QueryHookOptions<AllSpeciesQuery, AllSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSpeciesQuery, AllSpeciesQueryVariables>(AllSpeciesDocument, options);
      }
export function useAllSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSpeciesQuery, AllSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSpeciesQuery, AllSpeciesQueryVariables>(AllSpeciesDocument, options);
        }
export type AllSpeciesQueryHookResult = ReturnType<typeof useAllSpeciesQuery>;
export type AllSpeciesLazyQueryHookResult = ReturnType<typeof useAllSpeciesLazyQuery>;
export type AllSpeciesQueryResult = Apollo.QueryResult<AllSpeciesQuery, AllSpeciesQueryVariables>;